import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getNewsCategories = async () => {
  const response = await axios.get(`${base_url}country/CountryCategory`);
  
  return response.data;
  
};
const getNewsCategoriess = async (id) => {
  const response = await axios.get(`${base_url}country/CountryCategory/bycountryid/${id}`);
  console.log( response.data);
  return response.data;

  
};
const createNewsCategory = async (bcat) => {
  const id = bcat.countryNamee;
  delete bcat.countryNamee;
  const response = await axios.post(`${base_url}country/CountryCategory/${id}`, bcat, config);

  return response.data;
};
const updateNewsCategory = async (id,secondId,NewsCat) => {
  
  const response = await axios.put(
    `${base_url}country/CountryCategory/${id}/${secondId}`,
    { NewsCat }
  );

  return response.data;
};
const getNewsCategory = async (id,secondId) => {
  const response = await axios.get(`${base_url}country/CountryCategory/${id}/${secondId}`, config);
  console.log(response.data);
  return response.data;

};

const deleteNewsCategory = async (id,secondId) => {
  const response = await axios.delete(`${base_url}country/CountryCategory/${id}/${secondId}`, config);

  return response.data;
};
const bCategoryService = {
  getNewsCategories,
  getNewsCategoriess,
  createNewsCategory,
  deleteNewsCategory,
  getNewsCategory,
  updateNewsCategory,
};

export default bCategoryService;
